"use client";

import { createContext, useState } from "react";

/**
 * Export Status の開閉状態を管理するContext
 * SA、UAでの Export Button 押下後、ダイアログを開くために状態をContextとして管理する
 *
 * @see {@link file://./export-status.tsx}
 * @see {@link file://./export-button.tsx}
 */
export const ExportStatusContext = createContext<{
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}>({ isOpen: false, onOpen: () => {}, onClose: () => {} });

export function ExportStatusProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <ExportStatusContext
      value={{
        isOpen,
        onOpen: () => setIsOpen(true),
        onClose: () => setIsOpen(false),
      }}
    >
      {children}
    </ExportStatusContext>
  );
}
